import * as React from 'react';

import MediaQuery from 'ha/helpers/MediaQuery';
import Loader from 'ha/ui/next/Loader';

interface Props {
  loading: boolean;
}

const SearchResultsLoader: React.SFC<Props> = ({ loading }) =>
  loading ? (
    <MediaQuery>{({ lg }) => <Loader isFixed={!lg} />}</MediaQuery>
  ) : null;

export default SearchResultsLoader;
